<template>
    <div>
        <v-card>
            <v-toolbar flat color="white">
                <v-toolbar-title>{{ header }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark depressed :to="{ name: 'users.add' }" >Add User</v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-data-table :headers="headers" :loading="loading" :items="users" item-key="name" :pagination.sync="pagination" :rows-per-page-items="rowsPerPageItems" :total-items="totalUsers">
                <template slot="items" slot-scope="props">
                    <tr>
                        <td width="10">{{ props.item.id }}</td>
                        <td>{{ props.item.name}}</td>
                         <td>{{ props.item.email}}</td>
                        <td align="right">
                            <v-btn flat icon class="ma-0" @click="handleEdit( props.item.id,props.item.name,props.item.email); "  >
                                <v-icon small>edit</v-icon>
                            </v-btn>
                            <v-btn flat icon color="red darken-1"  class="ma-0" @click="delete_dialog = true; selected_user = props.item">
                                <v-icon small>delete</v-icon>
                            </v-btn>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
         <v-dialog v-model="delete_dialog" max-width="300">
          <v-card>
            <v-card-title class="headline">{{ selected_user.name }}</v-card-title>
            <v-card-text>Are you sure you want to delete?</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" flat @click="delete_dialog = false">No</v-btn>
              <v-btn color="green darken-1" flat @click="handleDelete( selected_user.id , selected_user.name )">Yes</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
                v-model="edit_dialog"
                width="500"
        >
          <!-- <edit-box :user="selected_user"> </edit-box> -->
            <v-card>
                <v-card>
                    <div>
                        <v-toolbar flat color="white">
                            <v-toolbar-title>Edit</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-divider></v-divider>
                    </div>
                    <div>
                        <v-container fluid>
                            <v-layout row>
                                <v-flex xs12 md12>
                                    <v-text-field
                                            label="Name"
                                            light
                                            name="name"
                                            :autofocus="true"
                                            v-model="edit_name"
                                            placeholder="Please enter Name "
                                            v-validate="'required'"
                                            :success="!errors.first('name')"
                                            :error-messages="errors.first('name')"
                                    ></v-text-field>
                                    <v-text-field
                                            label="Email"
                                            light
                                            name="email"
                                            :autofocus="true"
                                            v-model="edit_email"
                                            placeholder="Please enter Email "
                                            v-validate="'required'"
                                            :success="!errors.first('email')"
                                            :error-messages="errors.first('email')"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </div>

                     <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue " flat @click="edit_dialog = false">Close</v-btn>
                        <v-btn color="primary" depressed pull-right  @click="handleChange()">Submit</v-btn>
                    </v-card-actions>
                    <v-spacer></v-spacer>

                </v-card>
            </v-card>
        </v-dialog>

    </div>

</template>


<script>
  import Create from '~/pages/users/create.vue'
  import Edit from '~/pages/users/edit.vue'
  import Axios from 'axios';

  export default {
    components: {
      'edit-box' : Create
    },
    data() {
      return {
        url: '/api/v1/users',
        header: "Users",
        dialog: false,
        delete_dialog: false,
        edit_dialog: false,
        edit_name: '',
        edit_email:'',
        index_num: '',
        skip: 0,
        next: 0,
        prev: 0,
        perPage: 10,
        selected_user: [],
        pagination: {
          rowsPerPage: 10
        },
        headers: [
          { text: "ID", value:'id', sortable:true,  },
          { text: "Name", value: "name", sortable:true },
          { text: "Email", value: "email", sortable:true },
          { text: "Action", value: "action", sortable:false, align:"right"  }
        ],
        totalUsers: 0,
        users: [],
        loading: false,
        rowsPerPageItems: [5, 10, 25, 50]
      };
    },
    watch: {
      pagination: {
        handler (newVal, oldVal) {
          this.skip = (newVal.page - 1) * newVal.rowsPerPage || 0;

          if(newVal.rowsPerPage !== this.perPage){
            this.perPage = newVal.rowsPerPage;
            this.skip = 0;
          }
          this.getUsers()
        },
        deep: true
      }
    },
    methods: {
      getUrl () {
        const direction = this.pagination.descending ? 'asc' : 'desc';
        const sort = this.pagination.sortBy || 'id';
        return `${this.url}?limit=${this.perPage}&skip=${this.skip}&sort=${sort}&by=${direction}`;
      },
      async getUsers () {
        this.users = new Array();
        this.loading = !this.loading;
        const response = await Axios.get(this.getUrl());
        this.users = response.data.data;
        this.totalUsers = response.data.meta.cursor['count'];
        this.next = response.data.meta.cursor['next'];
        this.prev = response.data.meta.cursor['prev'];
        this.loading = !this.loading;
      },
      async handleDelete (id) {
        await Axios.delete('/api/v1/users/' + id).then((response) => {
          console.log(response);
          this.getUsers();
          this.delete_dialog=false;

        })
      },
      async handleEdit (id ,name, email){
        this.edit_dialog=true;
        this.index_num=id;
        this.edit_name=name;
        this.edit_email=email;
      },
      async handleChange(){

        await Axios.put('api/v1/users/' + this.index_num , {"data": {"id": this.index_num,"name": this.edit_name,"email":this.edit_email}}).then((response) => {

          console.log(response.data.data.name);
          this.getUsers();
          this.edit_dialog=false;
        })

      }


    }
  };
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/users/index.vue